import apiMethod from "../../../api/apiMethod";
import { getHash, getSearch, setcookie, rcookie } from "../../utils/utils";

const pCloudIntl = {
  //default
  _language: 'en',
  _toTranslateTimeout: null,
  _cookieName: 'lang',
  _cookieRememberDays: 30,
  _usedTranslatedStrings: [],
  _usedTimeout: null,
  _defaultLang: 'en',

  _languages: [
    { val: 'English', 		title: 'English', 	code: 'en', rtl: false },
    { val: 'Bulgarian', 	title: 'Български', code: 'bg', rtl: false },
    { val: 'Spanish', 		title: 'Еspañol', 	code: 'es', rtl: false },
    { val: 'Russian', 		title: 'Русский', 	code: 'ru', rtl: false },
    { val: 'Portuguese', 	title: 'Português', code: 'pt', rtl: false },
    { val: 'French', 		title: 'Français', 	code: 'fr', rtl: false },
    { val: 'Italian', 		title: 'Italiano', 	code: 'it', rtl: false },
    { val: 'German', 		title: 'Deutsch', 	code: 'de', rtl: false },
    { val: 'Tr. Chinese', 	title: '繁體中文', 	code: 'zh', rtl: false },
    { val: 'Turkish', 		title: 'Тürkçe', 	code: 'tr', rtl: false },
    { val: 'Dutch', 		title: 'Nederlands', 	code: 'nl', rtl: false },
    { val: 'Japanese', 		title: '日本語', 	code: 'ja', rtl: false }
    //{ val: 'Persian', 		title: 'فارسی', 	code: 'fa', rtl: true }
  ],

  //
  _notTranslatedStrings: {},
  _onChangeLanguage: function() {},

  __: function(key, val, repl) {
    var currentLang = this._language;

    if (DEBUG && typeof val == 'object' && val != null)
      alert('key ' + key + ' needs to be fixed, val: ' + val);

    key += ""; // tostring
    key = key.trim();

    // console.log("__ currentLang", currentLang);
    // console.log("__ lang", lang);
    // console.log("__ key", key);
    // console.log("__ key in lang[currentLang]", key in lang[currentLang]);

    if (lang != undefined && currentLang in lang && key in lang[currentLang]) {

      //this._usedString(key);

      return this._repl(lang[currentLang][key], repl);
    } else if (typeof translations !== "undefined" && currentLang in translations && key in translations[currentLang]) {
      return this._repl(translations[currentLang][key], repl);
    } else if (lang.en && key in lang.en) {
      return this._repl(lang.en[key], repl);
    } else {
      this._notTranslated(key, val);
      return this._repl(val || (lang[this._defaultLang] && lang[this._defaultLang][key]) || key, repl);
    }
  },

  _usedString: function(key) {
    if (this._usedTranslatedStrings.indexOf(key) === -1) {
      this._usedTranslatedStrings.push(key);
    }
  },

  _notTranslated: function(key, val) {
    if (val && val != key) {
      this._notTranslatedStrings[key] = val;
    }
  },

  _repl: function(str, repl) {
    // label replace
    if (globalProject.label && globalProject.label.translationReplace) {
      for (var i in globalProject.label.translationReplace)
        str = str.replace(new RegExp(i, 'g'), globalProject.label.translationReplace[i]);
    }

    str = this._properSpaces(str);

    if (!obLength(repl)) {
      return str;
    }

    for (var n in repl) {
      str = str.replace(new RegExp('\%' + n + '\%', 'g'), repl[n]);
    }

    return str;
  },

  _properSpaces: function(str) {
    return str.split(String.fromCharCode(160)).join(" ");
  },

  init: function (opts) {
    if (opts.language) {
      this._setLang(opts.language);
    }

    if (opts.onChangeLanguage) {
      this._onChangeLanguage = opts.onChangeLanguage;
    }
  },

  getLanguages: function() {
    return this._languages;
  },

  getSortedLanguages: function() {
    var self = this;

    return [this.getLangObj()].concat(this._languages.filter(function (lang) { return lang.code != self._language }));
  },

  getLanguagesHash: function() {
    return this._languages.map(function (lang) {
      var obj = {};
      obj[lang.code] = lang.title;
      return obj;
    });
  },

  getLanguageCodes: function () {
    return this._languages.map(function (lang) {
      return lang.code;
    });
  },

  _setLang: function (lang) {
    if (this.getLanguageCodes().indexOf(lang) != -1) {
      this._language = lang;
      return true;
    }

    return false;
  },

  setLang: function(lang) {
    this._setLang(lang);
  },

  updateLang: function (lang) {
    if (this._setLang(lang)) {
      this._onChangeLanguage();
    }
  },

  receivedLang: function(lang) {
    if (lang != this.getLang()) {
      this.setLang(lang);
    }
  },

  getLang: function() {
    return this._language;
  },

  getLangObj: function() {
    var self = this;
    return this._languages.filter(function (lang) {
      return lang.code == self._language;
    })[0];
  },

  setUserLang: function (lang) {
    if (globalUser.auth) {
      apiMethod('setlanguage', { language: lang }, function() {}, { errorCallback: function() {}});
    }

    setcookie(this._cookieName, lang, this._cookieRememberDays);

    this.updateLang(lang);
  },

  getCookieLang: function() {
    if (rcookie(this._cookieName))
      return rcookie(this._cookieName);
    return null;
  },

  getBrowserLang: function() {
    var langs = this.getLanguageCodes();
    var code;

    if (typeof navigator.languages == 'undefined') {
      return 'en';
    }

    for (var n = 0; n < navigator.languages.length; ++n) {
      code = navigator.languages[n].match(/^[a-z]{2}/i)[0].toLowerCase();

      if (this.getLanguageCodes().indexOf(code) != -1) {
        return code;
      }
    }

    return 'en';
  },

  getUserLanguage: function() {
    var lang = "en";
    var languageCodes = this.getLanguageCodes();
    var langFromUrl = getHash("lang") || getSearch("lang");

    if (globalProject.isDlink()) {
      if (globalDLink.data.language) {
        lang = globalDLink.data.language.toLowerCase();
      } else if (this.getCookieLang()) {
        lang = this.getCookieLang();
      }
    } else if (this.getCookieLang()) {
      lang = this.getCookieLang();

      if (
        globalUser.auth &&
        globalUser.user.language !== this.getCookieLang()
      ) {
        this.setUserLang(lang);
      }
    } else if (langFromUrl && languageCodes.indexOf(langFromUrl) !== -1) {
      lang = langFromUrl;
      this.setUserLang(lang);
    } else if (this.getBrowserLang()) {
      lang = this.getBrowserLang();
      this.setUserLang(lang);
    } else if (globalUser.auth) {
      lang = globalUser.user.language;
    }

    return lang;
  }
};

export const __ = (get, val, repl, description) => {
  return pCloudIntl.__(get, val, repl, description);
}

export default pCloudIntl